import React from 'react';

export const AlertIconSvg = props => {
  const { color } = props;
  return (
    <svg {...props} viewBox="0 0 17 17">
      <path
        id="error - material"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M8.5 17C10.0529 17 11.49 16.6118 12.8113 15.8353C14.0917 15.0998 15.0998 14.0917 15.8353 12.8113C16.6118 11.49 17 10.0529 17 8.5C17 6.94712 16.6118 5.51002 15.8353 4.1887C15.0998 2.90825 14.0917 1.90024 12.8113 1.16466C11.49 0.388221 10.0529 0 8.5 0C6.96074 0 5.53045 0.388221 4.20913 1.16466C2.92869 1.91386 1.91386 2.92869 1.16466 4.20913C0.388221 5.53045 0 6.96074 0 8.5C0 10.0393 0.388221 11.4696 1.16466 12.7909C1.90024 14.0713 2.90825 15.0861 4.1887 15.8353C5.51002 16.6118 6.94712 17 8.5 17ZM9.33774 9.33767H7.66226V4.22949H9.33774V9.33767ZM7.66226 12.7704H9.33774V11.0541H7.66226V12.7704Z"
      />
    </svg>
  );
};

export const AnnouncementIconSvg = props => (
  <svg {...props} viewBox="0 0 24 24">
    <path d="M19.18 0c-.143 0-.29.04-.427.125l-7.844 4.91H3.636C1.636 5.035 0 6.74 0 8.828v3.792c0 2.087 1.636 3.793 3.636 3.793h1.819v5.69c0 1.043.817 1.897 1.818 1.897 1 0 1.818-.854 1.818-1.897v-5.69h1.818l7.899 4.944c.13.082.272.12.409.12.407 0 .783-.33.783-.794V.83C20 .345 19.607 0 19.18 0m-1.66 3.85v13.749l-5.307-3.323-.6-.375H3.636c-.626 0-1.156-.586-1.156-1.28V8.827c0-.695.53-1.281 1.157-1.281h7.978l.599-.375 5.308-3.323M24 11.51c0-2.585-1.16-4.916-3-6.51v13c1.84-1.574 3-3.906 3-6.49" />
  </svg>
);

export const ApprovedIconSvg = props => (
  <svg {...props} viewBox="0 0 17 17">
    <path
      id="check_circle - material"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8113 15.8353C11.49 16.6118 10.0529 17 8.5 17C6.94712 17 5.51002 16.6118 4.1887 15.8353C2.90825 15.0861 1.90024 14.0713 1.16466 12.7909C0.388221 11.4696 0 10.0393 0 8.5C0 6.96074 0.388221 5.53045 1.16466 4.20913C1.91386 2.92869 2.92869 1.91386 4.20913 1.16466C5.53045 0.388221 6.96074 0 8.5 0C10.0529 0 11.49 0.388221 12.8113 1.16466C14.0917 1.90024 15.0998 2.90825 15.8353 4.1887C16.6118 5.51002 17 6.94712 17 8.5C17 10.0529 16.6118 11.49 15.8353 12.8113C15.0998 14.0917 14.0917 15.0998 12.8113 15.8353ZM2.55409 8.50002L6.78365 12.7705L14.4459 5.10819L13.2404 3.8618L6.78365 10.339L3.75961 7.29449L2.55409 8.50002Z"
    />
  </svg>
);

export const BusIconSvg = props => (
  <svg {...props} viewBox="0 0 16 19">
    <path d="M0 14C0 14.88 0.39 15.67 1 16.22V18C1 18.55 1.45 19 2 19H3C3.55 19 4 18.55 4 18V17H12V18C12 18.55 12.45 19 13 19H14C14.55 19 15 18.55 15 18V16.22C15.61 15.67 16 14.88 16 14V4C16 0.5 12.42 0 8 0C3.58 0 0 0.5 0 4V14ZM3.5 15C2.67 15 2 14.33 2 13.5C2 12.67 2.67 12 3.5 12C4.33 12 5 12.67 5 13.5C5 14.33 4.33 15 3.5 15ZM12.5 15C11.67 15 11 14.33 11 13.5C11 12.67 11.67 12 12.5 12C13.33 12 14 12.67 14 13.5C14 14.33 13.33 15 12.5 15ZM14 9H2V4H14V9Z" />
  </svg>
);

export const CancelIconSvg = props => (
  <svg {...props} viewBox="0 0 17 17">
    <path d="M8.5 0C3.808 0 0 3.808 0 8.5C0 13.192 3.808 17 8.5 17C13.192 17 17 13.192 17 8.5C17 3.808 13.192 0 8.5 0ZM1.7 8.5C1.7 4.743 4.743 1.7 8.5 1.7C10.0725 1.7 11.5175 2.2355 12.665 3.1365L3.1365 12.665C2.2355 11.5175 1.7 10.0725 1.7 8.5ZM8.5 15.3C6.9275 15.3 5.4825 14.7645 4.335 13.8635L13.8635 4.335C14.7645 5.4825 15.3 6.9275 15.3 8.5C15.3 12.257 12.257 15.3 8.5 15.3Z" />
  </svg>
);

export const ClosureIconSvg = props => (
  <svg {...props} viewBox="0 0 17 19">
    <path d="M5.95944 15.1111L8.26389 12.8067L10.5683 15.1111L11.5694 14.11L9.265 11.8056L11.5694 9.50111L10.5683 8.5L8.26389 10.8044L5.95944 8.5L4.95833 9.50111L7.26278 11.8056L4.95833 14.11L5.95944 15.1111ZM15.1111 1.88889H14.1667V0H12.2778V1.88889H4.72222V0H2.83333V1.88889H1.88889C0.840555 1.88889 0.00944444 2.73889 0.00944444 3.77778L0 17C0 18.0389 0.840555 18.8889 1.88889 18.8889H15.1111C16.15 18.8889 17 18.0389 17 17V3.77778C17 2.73889 16.15 1.88889 15.1111 1.88889ZM15.1111 17H1.88889V6.61111H15.1111V17Z" />
  </svg>
);

export const DocumentIconSvg = props => (
  <svg {...props} viewBox="0 0 15 17">
    <path
      id="file-multiple - materialregularcon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.75 14.161C13.1466 14.161 13.4838 14.025 13.7615 13.753C14.0391 13.481 14.178 13.1467 14.178 12.75V4.25L9.92798 0H4.24998C3.86464 0 3.53314 0.138833 3.25548 0.4165C2.97781 0.694166 2.83898 1.02567 2.83898 1.411V12.75C2.83898 13.1353 2.97498 13.4668 3.24698 13.7445C3.51898 14.0222 3.85331 14.161 4.24998 14.161H12.75ZM13.107 4.96403H9.214V1.05403L13.107 4.96403ZM12.75 15.589V17H1.428C1.03133 17 0.694166 16.864 0.4165 16.592C0.138833 16.32 0 15.9856 0 15.589V2.83898H1.428V15.589H12.75Z"
    />
  </svg>
);

export const EventIconSvg = props => (
  <svg {...props} viewBox="0 0 17 19">
    <path
      id="calendar-star - materialregularcon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1187 18.904C15.6476 18.904 16.0933 18.7189 16.456 18.3487C16.8187 17.9784 17 17.5289 17 17V3.78533C17 3.27156 16.8149 2.82956 16.4447 2.45933C16.0744 2.08911 15.6324 1.904 15.1187 1.904H14.1667V0H12.2853V1.904H4.71467V0H2.83333V1.904H1.88133C1.36756 1.904 0.925556 2.08911 0.555333 2.45933C0.185111 2.82956 0 3.27156 0 3.78533V17C0 17.5289 0.181333 17.9784 0.544 18.3487C0.906667 18.7189 1.35244 18.904 1.88133 18.904H15.1187ZM15.1187 17H1.88133V6.61865H15.1187V17ZM10.2 12.3987L11.2653 15.64L8.5 13.6453L5.73467 15.64L6.8 12.3987L4.03467 10.404H7.43467L8.5 7.14001L9.56534 10.404H12.9653L10.2 12.3987Z"
    />
  </svg>
);

export const HealthIconSvg = props => (
  <svg {...props} viewBox="0 0 16 17">
    <path
      id="thermometer-lines - materialregularcon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.15009 16.9733C7.39527 17.0549 6.67105 16.9495 5.97743 16.6571C5.2838 16.3647 4.70579 15.9125 4.24337 15.3004C3.78096 14.6884 3.50895 14.0084 3.42735 13.2604C3.34575 12.5124 3.45115 11.7915 3.74356 11.0979C4.03597 10.4043 4.48818 9.82629 5.1002 9.36387V2.55007C5.1002 2.08766 5.2158 1.66265 5.44701 1.27504C5.67822 0.887426 5.98763 0.578017 6.37524 0.34681C6.76285 0.115603 7.18786 0 7.65027 0C8.11269 0 8.5377 0.115603 8.92531 0.34681C9.31292 0.578017 9.62233 0.887426 9.85354 1.27504C10.0847 1.66265 10.2003 2.08766 10.2003 2.55007V9.36387C10.5132 9.58148 10.7988 9.86029 11.0572 10.2003C11.5196 10.8123 11.7916 11.4957 11.8732 12.2506C11.9548 13.0054 11.8494 13.7296 11.557 14.4232C11.2646 15.1168 10.8124 15.6949 10.2003 16.1573C9.58833 16.6197 8.90491 16.8917 8.15009 16.9733ZM15.3004 0.856822V2.55007H11.8935V0.856822H15.3004ZM3.4069 2.55007V0.856822H0V2.55007H3.4069ZM6.79338 5.10017H8.50703V2.5501C8.50703 2.31889 8.42203 2.12168 8.25202 1.95848C8.08202 1.79527 7.88141 1.71367 7.6502 1.71367C7.419 1.71367 7.21839 1.79527 7.04839 1.95848C6.87838 2.12168 6.79338 2.31889 6.79338 2.5501V5.10017ZM15.3004 5.95695V4.2637H11.8935V5.95695H15.3004ZM3.4069 4.2637V5.95695H0V4.2637H3.4069ZM15.3004 9.36388V7.65023H11.8935V8.58865L12.5464 9.36388H15.3004ZM3.4069 8.58865L2.75408 9.36388H0V7.65023H3.4069V8.58865ZM15.3004 12.7504V11.0571H13.3624C13.5256 11.5876 13.6072 12.152 13.6072 12.7504H15.3004ZM1.93806 11.0571C1.77485 11.6692 1.69325 12.2336 1.69325 12.7504H0V11.0571H1.93806Z"
    />
  </svg>
);

export const PendingIconSvg = props => (
  <svg {...props} viewBox="0 0 17 17">
    <path
      id="clock-outline - material_outline"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 17C10.0356 17 11.4624 16.6127 12.7806 15.8381C14.0715 15.0907 15.0907 14.0715 15.8381 12.7806C16.6127 11.4624 17 10.0356 17 8.5C17 6.96443 16.6127 5.53757 15.8381 4.21942C15.0907 2.92846 14.0715 1.90927 12.7806 1.16187C11.4624 0.38729 10.0356 0 8.5 0C6.96443 0 5.53757 0.38729 4.21942 1.16187C2.92846 1.90927 1.90927 2.92846 1.16187 4.21942C0.38729 5.53757 0 6.96443 0 8.5C0 10.0356 0.38729 11.4624 1.16187 12.7806C1.90927 14.058 2.92846 15.0771 4.21942 15.8381C5.53757 16.6127 6.96443 17 8.5 17ZM8.5 15.2878C7.27698 15.2878 6.1355 14.982 5.07554 14.3705C4.05636 13.759 3.24101 12.9436 2.6295 11.9245C2.01799 10.8645 1.71224 9.72303 1.71224 8.5C1.71224 7.27698 2.01799 6.1355 2.6295 5.07554C3.24101 4.05636 4.05636 3.24101 5.07554 2.6295C6.1355 2.01799 7.27698 1.71224 8.5 1.71224C9.72303 1.71224 10.8645 2.01799 11.9245 2.6295C12.9436 3.24101 13.759 4.05636 14.3705 5.07554C14.982 6.1355 15.2878 7.27698 15.2878 8.5C15.2878 9.72303 14.982 10.8645 14.3705 11.9245C13.759 12.9436 12.9436 13.759 11.9245 14.3705C10.8645 14.982 9.72303 15.2878 8.5 15.2878ZM12.7398 10.9868L12.1079 12.0264L7.64388 9.35612V4.2602H8.92806V8.70384L12.7398 10.9868Z"
    />
  </svg>
);

export const PhotoIconSvg = props => (
  <svg {...props} viewBox="0 0 17 17">
    <path
      id="image-multiple - materialregularcon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2878 13.5959C15.7634 13.5959 16.1677 13.4329 16.5006 13.1067C16.8335 12.7806 17 12.3797 17 11.9041V1.71223C17 1.23661 16.8335 0.832334 16.5006 0.4994C16.1677 0.166467 15.7634 0 15.2878 0H5.09591C4.62029 0 4.21941 0.166467 3.89328 0.4994C3.56714 0.832334 3.40407 1.23661 3.40407 1.71223V11.9041C3.40407 12.3661 3.57053 12.7636 3.90347 13.0965C4.2364 13.4295 4.63388 13.5959 5.09591 13.5959H15.2878ZM13.5959 17V15.2878H1.71223V3.40408H0V15.2878C0 15.7634 0.166467 16.1677 0.4994 16.5006C0.832334 16.8335 1.23661 17 1.71223 17H13.5959ZM5.09592 11.9041H15.2878L11.9041 7.64388L9.3765 10.8034L7.64388 8.5L5.09592 11.9041Z"
    />
  </svg>
);

export const PromotionIconSvg = props => (
  <svg {...props} viewBox="0 0 21 17">
    <path d="M3.77778 9.61444V13.3922L10.3889 17L17 13.3922V9.61444L10.3889 13.2222L3.77778 9.61444ZM10.3889 0L0 5.66667L10.3889 11.3333L18.8889 6.69611V13.2222H20.7778V5.66667L10.3889 0Z" />
  </svg>
);

export const RejectedIconSvg = props => (
  <svg {...props} viewBox="0 0 17 17">
    <path
      id="close-circle - materialregularcon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7806 15.8381C11.4624 16.6127 10.0356 17 8.5 17C6.96443 17 5.53757 16.6127 4.21942 15.8381C2.92846 15.0907 1.90927 14.0715 1.16187 12.7806C0.38729 11.4624 0 10.0356 0 8.5C0 6.96443 0.38729 5.53757 1.16187 4.21942C1.90927 2.92846 2.92846 1.90927 4.21942 1.16187C5.53757 0.38729 6.96443 0 8.5 0C10.0356 0 11.4624 0.38729 12.7806 1.16187C14.0715 1.90927 15.0907 2.92846 15.8381 4.21942C16.6127 5.53757 17 6.96443 17 8.5C17 10.0356 16.6127 11.4624 15.8381 12.7806C15.0907 14.0715 14.0715 15.0907 12.7806 15.8381ZM8.5 9.70264L11.5576 12.7398L12.7398 11.5576L9.70264 8.5L12.7398 5.44244L11.5576 4.26019L8.5 7.29736L5.44245 4.26019L4.26019 5.44244L7.29736 8.5L4.26019 11.5576L5.44245 12.7398L8.5 9.70264Z"
    />
  </svg>
);

export const ReturnIconSvg = props => (
  <svg {...props} viewBox="0 0 23 23">
    <path d="M3.32341 11.3066C3.32341 9.25603 4.09415 7.21249 5.65686 5.64978C8.78227 2.52437 13.8381 2.53144 16.9635 5.65685C20.0889 8.78227 20.096 13.8381 16.9706 16.9635C14.3331 19.601 10.3308 19.997 7.26199 18.1868L8.73277 16.716C10.9602 17.7837 13.7108 17.3948 15.5564 15.5493C17.8969 13.2088 17.8969 9.40452 15.5564 7.064C13.2158 4.72347 9.41159 4.72347 7.07107 7.064C5.89727 8.23779 5.33866 9.77221 5.34573 11.3066L9.8995 11.3066L4.94975 16.2564L3.54918e-06 11.3066L3.32341 11.3066Z" />
  </svg>
);

export const ScheduledIconSvg = props => (
  <svg {...props} viewBox="0 0 17 19">
    <path
      id="date_range - material"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.096 18.8587C15.6098 18.8587 16.0556 18.6773 16.4333 18.3147C16.8111 17.952 17 17.5138 17 17V3.76267C17 3.24889 16.8111 2.80311 16.4333 2.42533C16.0556 2.04756 15.6098 1.85867 15.096 1.85867H14.1667V0H12.2627V1.85867H4.73733V0H2.83333V1.85867H1.904C1.37511 1.85867 0.925556 2.04756 0.555333 2.42533C0.185111 2.80311 0 3.24889 0 3.76267V17C0 17.5138 0.185111 17.952 0.555333 18.3147C0.925556 18.6773 1.37511 18.8587 1.904 18.8587H15.096ZM15.096 17H1.90401V6.59599H15.096V17ZM13.2373 8.5V10.3587H11.3333V8.5H13.2373ZM9.42934 10.3587V8.5H7.57067V10.3587H9.42934ZM5.66666 8.5V10.3587H3.76266V8.5H5.66666Z"
    />
  </svg>
);

export const ApplicationDetailsSvg = props => (
  <svg
    {...props}
    width="28"
    height="34"
    viewBox="0 0 28 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3894 16.4688H4.26673C3.97218 16.4688 3.7334 16.7066 3.7334 17C3.7334 17.2934 3.97218 17.5312 4.26673 17.5312H15.4667L16.3894 16.4688Z"
      fill="#6C6C6C"
    />
    <path
      d="M18.2587 14.3438H4.26673C3.97218 14.3438 3.7334 14.5816 3.7334 14.875C3.7334 15.1684 3.97218 15.4062 4.26673 15.4062H17.3334L18.2587 14.3438Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.3333 32.9375C21.6279 32.9375 21.8667 32.6996 21.8667 32.4062V22.2886L22.9333 21.0773V32.4062C22.9333 33.2865 22.217 34 21.3333 34H1.6C0.716344 34 0 33.2865 0 32.4062V1.59375C0 0.713546 0.716344 0 1.6 0H13.8107L22.9333 8.55313V9.32078C22.6296 9.4722 22.3579 9.68053 22.1333 9.93438L21.8667 10.2425V9.03125H15.2C14.0213 9.03125 13.3333 8.34594 13.3333 7.17188V1.0625H1.6C1.30545 1.0625 1.06667 1.30035 1.06667 1.59375V32.4062C1.06667 32.6996 1.30545 32.9375 1.6 32.9375H21.3333ZM14.4 2.02405V7.17186C14.4 7.75889 14.6107 7.96873 15.2 7.96873H20.752L14.4 2.02405Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.1997 12.2213C27.5164 12.4988 27.7085 12.891 27.733 13.3104C27.7623 13.7319 27.6201 14.1474 27.3384 14.4632L14.4104 29.1549C14.3556 29.2167 14.2871 29.2649 14.2104 29.2957L9.26904 31.3065C9.08192 31.3826 8.86772 31.3467 8.7158 31.214C8.56388 31.0812 8.50035 30.8743 8.55171 30.6796L9.89837 25.5424C9.91935 25.4628 9.9586 25.3892 10.013 25.3273L22.933 10.6249C23.2141 10.3047 23.612 10.1096 24.0382 10.0832C24.4645 10.0567 24.8836 10.2011 25.2024 10.4842L27.1997 12.2213ZM13.197 28.5574L10.7437 26.52L9.85037 29.9174L13.197 28.5574ZM14.085 27.9093L11.237 25.5452L22.2397 13.0422L25.0877 15.4063L14.085 27.9093ZM25.7917 14.6094L26.5383 13.7594V13.7541C26.7247 13.5348 26.7023 13.2076 26.4877 13.0156L24.4797 11.2837C24.2587 11.0946 23.9263 11.1171 23.733 11.3342L22.933 12.2426L25.7917 14.6094Z"
      fill="#6C6C6C"
    />
    <path
      d="M4.99751 7.48779C4.04907 7.99817 3.46047 8.98793 3.46685 10.0617V12.2186C3.46685 12.512 3.70563 12.7498 4.00018 12.7498C4.29473 12.7498 4.53351 12.512 4.53351 12.2186V10.0617C4.52041 9.28789 4.99944 8.59025 5.72818 8.32186C5.43796 8.0881 5.19072 7.80588 4.99751 7.48779V7.48779Z"
      fill="#6C6C6C"
    />
    <path
      d="M11.4663 12.75C11.7608 12.75 11.9996 12.5122 11.9996 12.2188V10.0619C12.007 8.98719 11.4182 7.99617 10.4689 7.48535C10.276 7.80438 10.0287 8.08752 9.73828 8.32207C10.467 8.59046 10.9461 9.2881 10.9329 10.0619V12.2188C10.9329 12.5122 11.1717 12.75 11.4663 12.75Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.59961 5.84375C5.59961 4.67015 6.55474 3.71875 7.73294 3.71875C8.29874 3.71875 8.84136 3.94263 9.24144 4.34115C9.64151 4.73966 9.86628 5.28016 9.86628 5.84375C9.86628 7.01735 8.91115 7.96875 7.73294 7.96875C6.55474 7.96875 5.59961 7.01735 5.59961 5.84375ZM6.66626 5.84375C6.66626 6.43055 7.14382 6.90625 7.73293 6.90625C8.32203 6.90625 8.79959 6.43055 8.79959 5.84375C8.79959 5.25695 8.32203 4.78125 7.73293 4.78125C7.14382 4.78125 6.66626 5.25695 6.66626 5.84375Z"
      fill="#6C6C6C"
    />
    <path
      d="M14.5174 18.5938H4.26673C3.97218 18.5938 3.7334 18.8316 3.7334 19.125C3.7334 19.4184 3.97218 19.6562 4.26673 19.6562H13.5841L14.5174 18.5938Z"
      fill="#6C6C6C"
    />
    <path
      d="M12.6481 20.7188H4.26673C3.97218 20.7188 3.7334 20.9566 3.7334 21.25C3.7334 21.5434 3.97218 21.7812 4.26673 21.7812H11.7147L12.6481 20.7188Z"
      fill="#6C6C6C"
    />
    <path
      d="M10.7787 22.8438H4.26673C3.97218 22.8438 3.7334 23.0816 3.7334 23.375C3.7334 23.6684 3.97218 23.9062 4.26673 23.9062H9.84273L10.7787 22.8438Z"
      fill="#6C6C6C"
    />
    <path
      d="M8.86673 25.2742C8.89437 25.1688 8.93279 25.0664 8.9814 24.9688H4.26673C3.97218 24.9688 3.7334 25.2066 3.7334 25.5C3.7334 25.7934 3.97218 26.0312 4.26673 26.0312H8.66673L8.86673 25.2742Z"
      fill="#6C6C6C"
    />
    <path
      d="M19.2002 25.5C19.1996 25.4487 19.1915 25.3977 19.1762 25.3486L18.5762 26.0313H18.6668C18.9614 26.0313 19.2002 25.7934 19.2002 25.5Z"
      fill="#6C6C6C"
    />
    <path
      d="M3.7334 27.625C3.7334 27.9184 3.97218 28.1562 4.26673 28.1562H8.1094L8.37607 27.0938H4.26673C3.97218 27.0938 3.7334 27.3316 3.7334 27.625Z"
      fill="#6C6C6C"
    />
    <path
      d="M19.2001 27.625C19.2001 27.3316 18.9613 27.0938 18.6668 27.0938H17.6401L16.7041 28.1562H18.6668C18.9613 28.1562 19.2001 27.9184 19.2001 27.625Z"
      fill="#6C6C6C"
    />
  </svg>
);

export const AdditionalInformationSvg = props => (
  <svg
    {...props}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.5484 4.83871H26.129V3.3871C26.129 2.58677 25.4777 1.93548 24.6774 1.93548H12.2434L9.70597 0.243871C9.46645 0.0841932 9.18823 0 8.90081 0H1.45161C0.65129 0 0 0.65129 0 1.45161V15.9677C0 17.3018 1.08532 18.3871 2.41935 18.3871H8.96613C10.0969 19.7947 11.7073 20.7982 13.5484 21.149V22.2581H12.5806V27.5806C12.5806 28.9147 13.666 30 15 30C16.334 30 17.4194 28.9147 17.4194 27.5806V22.2581H16.4516V21.149C18.2927 20.7977 19.9031 19.7947 21.0339 18.3871H27.5806C28.9147 18.3871 30 17.3018 30 15.9677V6.29032C30 5.49 29.3487 4.83871 28.5484 4.83871ZM1.45164 0.967773H8.90084C8.99664 0.967773 9.08955 0.995838 9.16939 1.04906L11.9502 2.90326H24.6775C24.9441 2.90326 25.1613 3.12052 25.1613 3.38713V3.871H0.967773V1.45164C0.967773 1.18503 1.18503 0.967773 1.45164 0.967773ZM15 29.0323C15.8003 29.0323 16.4516 28.381 16.4516 27.5807V23.2258H13.5484V27.5807C13.5484 28.381 14.1997 29.0323 15 29.0323ZM15.4839 22.258H14.5161V21.2656L14.5832 21.2701L14.627 21.2731C14.7505 21.2817 14.8741 21.2903 15 21.2903C15.1259 21.2903 15.2495 21.2817 15.373 21.2731L15.3732 21.2731L15.3735 21.2731L15.3737 21.2731C15.4104 21.2705 15.4471 21.268 15.4839 21.2656V22.258ZM8.22583 13.5484C8.22583 17.2838 11.2645 20.3226 15 20.3226C18.7355 20.3226 21.7742 17.2838 21.7742 13.5484C21.7742 9.81288 18.7355 6.77417 15 6.77417C11.2645 6.77417 8.22583 9.81288 8.22583 13.5484ZM22.742 13.5484C22.742 9.27971 19.2687 5.80649 15 5.80649C10.7313 5.80649 7.2581 9.27971 7.2581 13.5484C7.2581 14.9594 7.64374 16.2789 8.30568 17.4194H2.41939C1.61906 17.4194 0.967773 16.7681 0.967773 15.9678V4.83875H25.1613V15.9678C25.1613 16.5146 25.3505 17.0139 25.6578 17.4194H21.6944C22.3563 16.2789 22.742 14.9594 22.742 13.5484ZM27.5806 17.4193C28.381 17.4193 29.0323 16.768 29.0323 15.9677V6.29027C29.0323 6.02365 28.815 5.8064 28.5484 5.8064H26.129V15.9677C26.129 16.768 26.7803 17.4193 27.5806 17.4193Z"
      fill="#6C6C6C"
    />
    <rect
      x="1.93555"
      y="1.93555"
      width="6.77419"
      height="0.967742"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.19336 13.5486C9.19336 10.3469 11.798 7.74219 14.9998 7.74219C18.2016 7.74219 20.8063 10.3469 20.8063 13.5486C20.8063 16.7504 18.2016 19.3551 14.9998 19.3551C11.798 19.3551 9.19336 16.7504 9.19336 13.5486ZM10.1611 13.5487C10.1611 16.2167 12.3317 18.3874 14.9998 18.3874C17.6678 18.3874 19.8385 16.2167 19.8385 13.5487C19.8385 10.8806 17.6678 8.70996 14.9998 8.70996C12.3317 8.70996 10.1611 10.8806 10.1611 13.5487Z"
      fill="#6C6C6C"
    />
    <circle cx="14.9995" cy="10.1611" r="0.483871" fill="#6C6C6C" />
    <path
      d="M13.5488 12.5805H14.5166V16.4515H13.5488V17.4192H16.4521V16.4515H15.4843V12.5805H16.4521V11.6128H13.5488V12.5805Z"
      fill="#6C6C6C"
    />
    <rect
      x="1.93555"
      y="5.80664"
      width="4.35484"
      height="0.967742"
      fill="#6C6C6C"
    />
    <rect
      x="1.93555"
      y="7.74219"
      width="4.35484"
      height="0.967742"
      fill="#6C6C6C"
    />
    <rect
      x="5.32227"
      y="9.67725"
      width="0.967742"
      height="0.967742"
      fill="#6C6C6C"
    />
    <rect
      x="1.93555"
      y="9.67725"
      width="2.41935"
      height="0.967742"
      fill="#6C6C6C"
    />
  </svg>
);

export const DocumentsSvg = props => (
  <svg
    {...props}
    width="25"
    height="30"
    viewBox="0 0 25 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.741248 0.000749588C0.393587 0.033865 0.128383 0.329627 0.129889 0.68255V29.3182C0.129917 29.6947 0.431928 30 0.804492 30H23.741C24.1135 30 24.4155 29.6947 24.4156 29.3182V6.81876C24.417 6.63479 24.3447 6.45807 24.2153 6.32871L18.1439 0.192504C18.0168 0.0682173 17.8464 -0.000642776 17.6696 0.000749588H0.804492C0.783422 -0.000249863 0.762317 -0.000249863 0.741248 0.000749588ZM1.47913 1.36438H16.995V6.81879C16.995 7.19532 17.297 7.50055 17.6696 7.50059H23.0664V28.6364H1.47913V1.36438ZM22.1177 6.13694L18.3441 2.32312V6.13694H22.1177ZM8.80485 13.2958C8.68936 13.3135 8.5804 13.3613 8.48863 13.4343L4.10372 16.8433C3.89124 16.9836 3.77462 17.2325 3.80189 17.4875C3.82916 17.7425 3.99571 17.9605 4.23293 18.0516C4.47015 18.1427 4.7379 18.0916 4.92589 17.9193L8.22511 15.3519V22.841C8.22167 23.0869 8.34949 23.3156 8.55963 23.4396C8.76977 23.5635 9.02967 23.5635 9.2398 23.4396C9.44994 23.3156 9.57776 23.0869 9.57432 22.841V15.3519L12.8735 17.9193C13.0615 18.0916 13.3293 18.1427 13.5665 18.0516C13.8037 17.9605 13.9703 17.7425 13.9975 17.4875C14.0248 17.2325 13.9082 16.9836 13.6957 16.8433L9.3108 13.4343C9.16751 13.3211 8.98508 13.2712 8.80485 13.2958ZM3.88296 25.255C3.99373 25.0383 4.21048 24.8978 4.45155 24.8865C4.47262 24.8855 4.49372 24.8855 4.51479 24.8865H13.2846C13.5279 24.883 13.7542 25.0122 13.8768 25.2246C13.9995 25.437 13.9995 25.6996 13.8768 25.912C13.7542 26.1244 13.5279 26.2536 13.2846 26.2501H4.51479C4.27373 26.2616 4.04492 26.1422 3.91459 25.9369C3.78425 25.7317 3.77219 25.4717 3.88296 25.255Z"
      fill="#6C6C6C"
    />
  </svg>
);

export const ConsentSvg = props => (
  <svg
    {...props}
    width="30"
    height="33"
    viewBox="0 0 30 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.94642 0C1.32549 0 0 1.31298 0 2.91869V4.24536C3.21428e-05 4.5384 0.23986 4.77603 0.535713 4.77603H10.7143H19.8214C20.1173 4.77603 20.3571 4.5384 20.3571 4.24536V2.91869C20.3571 1.88664 21.1902 1.06134 22.2321 1.06134C23.274 1.06134 24.1071 1.88664 24.1071 2.91869V25.2063C24.1071 26.8119 25.4326 28.125 27.0535 28.125C28.6754 28.1133 30.0088 26.7971 30 25.2063C29.9999 24.9133 29.7601 24.6756 29.4642 24.6756H26.25C25.5255 24.665 25.5255 25.7471 26.25 25.737H28.8469C28.6158 26.52 27.8855 27.0637 27.0535 27.0637C26.0117 27.0637 25.1785 26.2383 25.1785 25.2063V2.91869C25.1785 1.31298 23.853 0 22.2321 0C15.8359 0.00053067 9.36732 0 2.94642 0ZM2.94641 1.06139H19.9658C19.5216 1.57274 19.2857 2.19098 19.2857 2.9146V3.7106H10.7143H1.07141V2.9146C1.07141 1.88255 1.90454 1.05693 2.94641 1.05725V1.06139Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 4.375V25.2222C3.75 26.819 5.05096 28.125 6.64188 28.125H10V27.0694H6.64188C5.6193 27.0694 4.80159 26.2485 4.80159 25.2222V4.375H3.75Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7833 6.25005C16.5936 6.24723 16.4172 6.36573 16.3217 6.56025C16.2261 6.75476 16.2261 6.99524 16.3217 7.18975C16.4172 7.38427 16.5936 7.50277 16.7833 7.49995H20.7167C20.9064 7.50277 21.0828 7.38427 21.1783 7.18975C21.2739 6.99524 21.2739 6.75476 21.1783 6.56025C21.0828 6.36573 20.9064 6.24723 20.7167 6.25005H16.7833Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00652 6.25005C7.82632 6.24723 7.65883 6.36573 7.56807 6.56024C7.47731 6.75476 7.47731 6.99524 7.56807 7.18976C7.65883 7.38427 7.82632 7.50277 8.00652 7.49995H9.49348C9.67368 7.50277 9.84117 7.38427 9.93193 7.18976C10.0227 6.99524 10.0227 6.75476 9.93193 6.56024C9.84117 6.36573 9.67368 6.24723 9.49348 6.25005H8.00652Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7716 6.25005C11.586 6.24723 11.4135 6.36573 11.3201 6.56025C11.2266 6.75476 11.2266 6.99524 11.3201 7.18975C11.4135 7.38427 11.586 7.50277 11.7716 7.49995H15.1034C15.289 7.50277 15.4615 7.38427 15.5549 7.18975C15.6484 6.99524 15.6484 6.75476 15.5549 6.56025C15.4615 6.36573 15.289 6.24723 15.1034 6.25005H11.7716Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5276 13.125C10.3399 13.1222 10.1654 13.2407 10.0709 13.4352C9.97637 13.6298 9.97637 13.8702 10.0709 14.0648C10.1654 14.2593 10.3399 14.3778 10.5276 14.375H18.8474C19.0351 14.3778 19.2096 14.2593 19.3041 14.0648C19.3986 13.8702 19.3986 13.6298 19.3041 13.4352C19.2096 13.2407 19.0351 13.1222 18.8474 13.125H10.5276Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.656 10.625C13.4671 10.6222 13.2915 10.7407 13.1964 10.9352C13.1012 11.1298 13.1012 11.3702 13.1964 11.5648C13.2915 11.7593 13.4671 11.8778 13.656 11.875H20.719C20.9079 11.8778 21.0835 11.7593 21.1786 11.5648C21.2738 11.3702 21.2738 11.1298 21.1786 10.9352C21.0835 10.7407 20.9079 10.6222 20.719 10.625H13.656Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.06294 10.625C7.86266 10.6222 7.67652 10.7407 7.57565 10.9352C7.47478 11.1298 7.47478 11.3702 7.57565 11.5648C7.67652 11.7593 7.86266 11.8778 8.06294 11.875H11.9371C12.1373 11.8778 12.3235 11.7593 12.4243 11.5648C12.5252 11.3702 12.5252 11.1298 12.4243 10.9352C12.3235 10.7407 12.1373 10.6222 11.9371 10.625H8.06294Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2569 8.75005C19.0766 8.74723 18.909 8.86573 18.8181 9.06024C18.7273 9.25476 18.7273 9.49524 18.8181 9.68976C18.909 9.88427 19.0766 10.0028 19.2569 9.99995H20.7431C20.9234 10.0028 21.091 9.88427 21.1819 9.68976C21.2727 9.49524 21.2727 9.25476 21.1819 9.06024C21.091 8.86573 20.9234 8.74723 20.7431 8.75005H19.2569Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.04278 8.75005C7.84968 8.74723 7.6702 8.86573 7.57294 9.06024C7.47569 9.25476 7.47569 9.49524 7.57294 9.68976C7.6702 9.88427 7.84968 10.0028 8.04278 9.99995H12.5822C12.7753 10.0028 12.9548 9.88427 13.0521 9.68976C13.1493 9.49524 13.1493 9.25476 13.0521 9.06024C12.9548 8.86573 12.7753 8.74723 12.5822 8.75005H8.04278Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2567 8.75005C14.0764 8.74723 13.9089 8.86573 13.8181 9.06024C13.7273 9.25476 13.7273 9.49524 13.8181 9.68976C13.9089 9.88427 14.0764 10.0028 14.2567 9.99995H16.9933C17.1736 10.0028 17.3411 9.88427 17.4319 9.68976C17.5227 9.49524 17.5227 9.25476 17.4319 9.06024C17.3411 8.86573 17.1736 8.74723 16.9933 8.75005H14.2567Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.375 21.25C9.375 18.4949 11.6198 16.25 14.375 16.25C17.1302 16.25 19.375 18.4949 19.375 21.25C19.375 24.0052 17.1302 26.25 14.375 26.25C11.6198 26.25 9.375 24.0052 9.375 21.25ZM18.3223 21.25C18.3223 19.0638 16.5613 17.3026 14.375 17.3026C12.1887 17.3026 10.4276 19.0638 10.4276 21.25C10.4276 23.4362 12.1887 25.1973 14.375 25.1973C16.5613 25.1973 18.3223 23.4362 18.3223 21.25Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.875 20.9374C11.875 19.3909 13.1409 18.125 14.6875 18.125C16.2341 18.125 17.5 19.3909 17.5 20.9374C17.5 22.4841 16.2342 23.75 14.6875 23.75C13.1408 23.75 11.875 22.4841 11.875 20.9374ZM16.375 20.9374C16.375 19.9988 15.6261 19.25 14.6875 19.25C13.7489 19.25 13 19.9988 13 20.9374C13 21.876 13.7488 22.625 14.6875 22.625C15.6262 22.625 16.375 21.876 16.375 20.9374Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 25V31.9636C11.2501 32.1567 11.351 32.3349 11.5143 32.4302C11.6776 32.5254 11.878 32.5231 12.0391 32.424L14.376 30.9823L16.7109 32.424C16.872 32.5231 17.0724 32.5254 17.2357 32.4302C17.399 32.3349 17.4999 32.1567 17.5 31.9636V25H16.4566V31.0157L14.6424 29.8963C14.4777 29.7951 14.2723 29.7951 14.1076 29.8963L12.2934 31.0157V25L11.25 25Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 16.875V19.375H15V16.875H13.75Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20.625V21.875H12.5V20.625H10Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 20.625V21.875H18.75V20.625H16.25Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 23.75V30H15V23.75H13.75Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.75 27.5V28.75H26.875V27.5H18.75Z"
      fill="#6C6C6C"
    />
  </svg>
);

export const GiroSetupSvg = props => (
  <svg
    {...props}
    width="26"
    height="33"
    viewBox="0 0 26 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5502 30.8C22.854 30.8 23.1002 30.5538 23.1002 30.25V6.05C23.1002 5.74624 22.854 5.5 22.5502 5.5H2.7502C2.44644 5.5 2.2002 5.74624 2.2002 6.05V30.25C2.2002 30.5538 2.44644 30.8 2.7502 30.8H22.5502ZM3.30029 6.59998H22.0003V16.5H3.30029V6.59998ZM22.0003 17.6H3.30029V29.7H22.0003V17.6Z"
      fill="#6C6C6C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3 30.25C25.2982 31.768 24.068 32.9982 22.55 33H2.75C1.23197 32.9982 0.00181836 31.768 0 30.25V2.75C0.00181836 1.23197 1.23197 0.00181818 2.75 0H22.55C24.068 0.00181818 25.2982 1.23197 25.3 2.75V30.25ZM1.09998 2.74998V30.25C1.09998 31.1612 1.83871 31.9 2.74998 31.9H22.55C23.4612 31.9 24.2 31.1612 24.2 30.25V2.74998C24.2 1.83871 23.4612 1.09998 22.55 1.09998H2.74998C1.83871 1.09998 1.09998 1.83871 1.09998 2.74998Z"
      fill="#6C6C6C"
    />
    <rect x="4.40039" y="9.8999" width="1.1" height="1.1" fill="#6C6C6C" />
    <rect x="6.59961" y="9.8999" width="4.4" height="1.1" fill="#6C6C6C" />
    <rect x="4.40039" y="18.7002" width="1.1" height="1.1" fill="#6C6C6C" />
    <rect x="6.59961" y="18.7002" width="4.4" height="1.1" fill="#6C6C6C" />
    <rect x="4.40039" y="20.8999" width="1.1" height="1.1" fill="#6C6C6C" />
    <rect x="6.59961" y="20.8999" width="4.4" height="1.1" fill="#6C6C6C" />
    <rect x="17.0498" y="9.8999" width="3.85" height="1.1" fill="#6C6C6C" />
    <path
      d="M18.6996 19.7998H17.5996V20.8998H15.3996C15.0959 20.8998 14.8496 21.146 14.8496 21.4498V23.6498C14.8496 23.9536 15.0959 24.1998 15.3996 24.1998H19.7996V25.2998H14.8496V26.3998H17.5996V27.4998H18.6996V26.3998H20.3496C20.6534 26.3998 20.8996 26.1536 20.8996 25.8498V23.6498C20.8996 23.346 20.6534 23.0998 20.3496 23.0998H15.9496V21.9998H20.8996V20.8998H18.6996V19.7998Z"
      fill="#6C6C6C"
    />
  </svg>
);

export const PaymentSvg = props => (
  <svg
    {...props}
    width="22"
    height="33"
    viewBox="0 0 22 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6542 18.645C21.1855 17.6717 21.358 16.5426 21.1415 15.455L20.35 11.495V1.65C20.35 0.73873 19.6113 0 18.7 0H12.1C11.1887 0 10.45 0.73873 10.45 1.65V2.8996L9.03925 1.48885C8.72981 1.17935 8.31008 1.00548 7.87243 1.00548C7.43477 1.00548 7.01504 1.17935 6.7056 1.48885L2.03885 6.1556C1.39587 6.80061 1.39587 7.84424 2.03885 8.48925L2.4277 8.8781H1.65C0.73873 8.8781 0 9.61683 0 10.5281V17.1281C0 18.0394 0.73873 18.7781 1.65 18.7781H8.81485C8.45131 19.2516 8.25291 19.8312 8.25 20.4281V21.5281C8.25154 22.619 8.89942 23.6053 9.9 24.0399V25.3H8.8C8.49624 25.3 8.25 25.5462 8.25 25.85V29.15C8.25 29.4538 8.49624 29.7 8.8 29.7H9.35V32.45C9.35 32.7538 9.59624 33 9.9 33H18.7C19.0038 33 19.25 32.7538 19.25 32.45V29.7H19.8C20.1038 29.7 20.35 29.4538 20.35 29.15V25.85C20.35 25.5462 20.1038 25.3 19.8 25.3H18.7V22.22L20.6542 18.645ZM11.55 1.64998C11.55 1.34622 11.7963 1.09998 12.1 1.09998H18.7C19.0038 1.09998 19.25 1.34622 19.25 1.64998V12.65C19.25 12.9537 19.0038 13.2 18.7 13.2H13.4024C13.0005 12.5649 12.3017 12.1794 11.55 12.1781V1.64998ZM7.87245 2.10583C7.72647 2.10583 7.58649 2.16387 7.48332 2.26714L7.15002 2.60099L10.45 5.90099V4.45504L8.26157 2.26714C8.15841 2.16387 8.01842 2.10583 7.87245 2.10583ZM6.14949 3.60086L6.36949 3.38086L10.4499 7.45636V9.01231L5.59399 4.15636L6.14949 3.60086ZM4.81632 4.93408L2.81652 6.93333C2.71281 7.03663 2.65456 7.17702 2.65466 7.3234C2.65477 7.46978 2.71322 7.61008 2.81707 7.71323L9.36207 14.2582C9.40293 13.5217 9.81185 12.8552 10.45 12.485V10.5677L4.81632 4.93408ZM1.09998 10.5281C1.09998 10.2244 1.34622 9.97815 1.64998 9.97815H3.52768L4.54958 11H1.09998V10.5281ZM5.49998 12.1H1.09998V13.2H6.74958L5.62428 12.0747C5.58402 12.0881 5.54228 12.0966 5.49998 12.1ZM1.64998 17.6781C1.34622 17.6781 1.09998 17.4318 1.09998 17.1281V14.3H7.69998C7.74228 14.2966 7.78402 14.2881 7.82428 14.2747L9.33843 15.7888C9.34008 15.7905 9.34214 15.7916 9.3442 15.7927L9.34761 15.7946C9.34845 15.7952 9.34925 15.7958 9.34998 15.7965V17.6781H1.64998ZM10.45 31.9H18.15V29.7H10.45V31.9ZM19.25 26.4V28.6H9.34998V26.4H19.25ZM17.6 22.0781C17.5999 21.9858 17.6232 21.895 17.6676 21.8141L19.6889 18.1175C20.0968 17.3706 20.2294 16.5042 20.0634 15.6695L19.7169 13.9392C19.4286 14.1712 19.07 14.2984 18.7 14.3H13.75V14.3781C13.75 14.3859 13.7476 14.3932 13.7452 14.4004C13.7426 14.4083 13.7401 14.4162 13.7406 14.4248C13.7411 14.4325 13.7432 14.4397 13.7453 14.4467C13.7476 14.4548 13.75 14.4628 13.75 14.4716V17.7716C13.75 18.0753 13.5037 18.3216 13.2 18.3216C12.8962 18.3216 12.65 18.0753 12.65 17.7716V14.4716C12.65 14.4637 12.6524 14.4565 12.6547 14.4492C12.6573 14.4413 12.6599 14.4335 12.6593 14.4248C12.6588 14.4171 12.6567 14.41 12.6547 14.4029C12.6523 14.3949 12.65 14.3869 12.65 14.3781C12.65 13.7706 12.1575 13.2781 11.55 13.2781C10.9425 13.2781 10.45 13.7706 10.45 14.3781V18.535C10.449 18.7305 10.3443 18.9108 10.175 19.0085C9.66454 19.2987 9.34946 19.8409 9.34998 20.4281V21.5281C9.35257 22.278 9.86154 22.9315 10.588 23.1176C10.8306 23.1805 11 23.3994 11 23.65V25.3H17.6V22.0781Z"
      fill="#6C6C6C"
    />
  </svg>
);

export const ApplicationStepIconSvg = props => (
  <svg {...props} viewBox="0 0 28 34" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.3893 16.4688H4.26667C3.97212 16.4688 3.73334 16.7066 3.73334 17C3.73334 17.2934 3.97212 17.5312 4.26667 17.5312H15.4667L16.3893 16.4688Z" />
    <path d="M18.2587 14.3438H4.26667C3.97212 14.3438 3.73334 14.5816 3.73334 14.875C3.73334 15.1684 3.97212 15.4062 4.26667 15.4062H17.3333L18.2587 14.3438Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.3333 32.9375C21.6279 32.9375 21.8667 32.6996 21.8667 32.4062V22.2886L22.9333 21.0773V32.4062C22.9333 33.2865 22.217 34 21.3333 34H1.6C0.716344 34 0 33.2865 0 32.4062V1.59375C0 0.713546 0.716344 0 1.6 0H13.8107L22.9333 8.55313V9.32078C22.6296 9.4722 22.3579 9.68053 22.1333 9.93437L21.8667 10.2425V9.03125H15.2C14.0213 9.03125 13.3333 8.34594 13.3333 7.17188V1.0625H1.6C1.30545 1.0625 1.06667 1.30035 1.06667 1.59375V32.4062C1.06667 32.6996 1.30545 32.9375 1.6 32.9375H21.3333ZM14.4 2.02406V7.17188C14.4 7.75891 14.6107 7.96875 15.2 7.96875H20.752L14.4 2.02406Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.2 12.2213C27.5167 12.4988 27.7088 12.891 27.7333 13.3104C27.7626 13.7319 27.6204 14.1474 27.3387 14.4632L14.4107 29.1549C14.3559 29.2167 14.2874 29.2649 14.2107 29.2957L9.26934 31.3065C9.08223 31.3826 8.86802 31.3467 8.71611 31.214C8.56419 31.0812 8.50065 30.8743 8.55201 30.6796L9.89868 25.5424C9.91965 25.4628 9.95891 25.3892 10.0133 25.3273L22.9333 10.6249C23.2144 10.3047 23.6123 10.1096 24.0385 10.0832C24.4648 10.0567 24.8839 10.2011 25.2027 10.4842L27.2 12.2213ZM13.1973 28.5573L10.744 26.5199L9.85068 29.9173L13.1973 28.5573ZM14.0853 27.9092L11.2373 25.5451L22.24 13.0421L25.088 15.4062L14.0853 27.9092ZM25.792 14.6093L26.5387 13.7593V13.754C26.725 13.5347 26.7026 13.2076 26.488 13.0156L24.48 11.2837C24.259 11.0946 23.9266 11.117 23.7333 11.3342L22.9333 12.2426L25.792 14.6093Z"
    />
    <path d="M4.99733 7.48828C4.04888 7.99866 3.46029 8.98842 3.46667 10.0622V12.2191C3.46667 12.5125 3.70545 12.7503 4 12.7503C4.29455 12.7503 4.53333 12.5125 4.53333 12.2191V10.0622C4.52022 9.28838 4.99926 8.59074 5.728 8.32234C5.43777 8.08859 5.19054 7.80637 4.99733 7.48828V7.48828Z" />
    <path d="M11.4667 12.7491C11.7612 12.7491 12 12.5112 12 12.2178V10.0609C12.0074 8.98622 11.4186 7.9952 10.4693 7.48438C10.2764 7.80341 10.0291 8.08654 9.73868 8.32109C10.4674 8.58949 10.9465 9.28713 10.9333 10.0609V12.2178C10.9333 12.5112 11.1721 12.7491 11.4667 12.7491Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.60001 5.84375C5.60001 4.67014 6.55513 3.71875 7.73334 3.71875C8.29913 3.71875 8.84176 3.94263 9.24183 4.34115C9.64191 4.73966 9.86667 5.28016 9.86667 5.84375C9.86667 7.01735 8.91155 7.96875 7.73334 7.96875C6.55513 7.96875 5.60001 7.01735 5.60001 5.84375ZM6.66666 5.84375C6.66666 6.43055 7.14422 6.90625 7.73332 6.90625C8.32243 6.90625 8.79999 6.43055 8.79999 5.84375C8.79999 5.25695 8.32243 4.78125 7.73332 4.78125C7.14422 4.78125 6.66666 5.25695 6.66666 5.84375Z"
    />
    <path d="M14.5173 18.5938H4.26667C3.97212 18.5938 3.73334 18.8316 3.73334 19.125C3.73334 19.4184 3.97212 19.6562 4.26667 19.6562H13.584L14.5173 18.5938Z" />
    <path d="M12.648 20.7188H4.26667C3.97212 20.7188 3.73334 20.9566 3.73334 21.25C3.73334 21.5434 3.97212 21.7812 4.26667 21.7812H11.7147L12.648 20.7188Z" />
    <path d="M10.7787 22.8438H4.26667C3.97212 22.8438 3.73334 23.0816 3.73334 23.375C3.73334 23.6684 3.97212 23.9062 4.26667 23.9062H9.84267L10.7787 22.8438Z" />
    <path d="M8.86667 25.2742C8.89431 25.1688 8.93273 25.0664 8.98134 24.9688H4.26667C3.97212 24.9688 3.73334 25.2066 3.73334 25.5C3.73334 25.7934 3.97212 26.0312 4.26667 26.0312H8.66667L8.86667 25.2742Z" />
    <path d="M19.2 25.4991C19.1994 25.4477 19.1913 25.3967 19.176 25.3477L18.576 26.0303H18.6667C18.9612 26.0303 19.2 25.7925 19.2 25.4991Z" />
    <path d="M3.73334 27.625C3.73334 27.9184 3.97212 28.1562 4.26667 28.1562H8.10934L8.376 27.0938H4.26667C3.97212 27.0938 3.73334 27.3316 3.73334 27.625Z" />
    <path d="M19.2 27.625C19.2 27.3316 18.9612 27.0938 18.6667 27.0938H17.64L16.704 28.1562H18.6667C18.9612 28.1562 19.2 27.9184 19.2 27.625Z" />
  </svg>
);

export const AdditionalInfoIconSvg = props => (
  <svg {...props} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.5484 4.83871H26.129V3.3871C26.129 2.58677 25.4777 1.93548 24.6774 1.93548H12.2434L9.70597 0.243871C9.46645 0.0841936 9.18823 0 8.90081 0H1.45161C0.65129 0 0 0.65129 0 1.45161V15.9677C0 17.3018 1.08532 18.3871 2.41935 18.3871H8.96613C10.0969 19.7947 11.7073 20.7982 13.5484 21.149V22.2581H12.5806V27.5806C12.5806 28.9147 13.666 30 15 30C16.334 30 17.4194 28.9147 17.4194 27.5806V22.2581H16.4516V21.149C18.2927 20.7977 19.9031 19.7947 21.0339 18.3871H27.5806C28.9147 18.3871 30 17.3018 30 15.9677V6.29032C30 5.49 29.3487 4.83871 28.5484 4.83871ZM1.45161 0.967743H8.90081C8.99661 0.967743 9.08952 0.995807 9.16936 1.04903L11.9502 2.90323H24.6774C24.944 2.90323 25.1613 3.12048 25.1613 3.3871V3.87097H0.967743V1.45161C0.967743 1.185 1.185 0.967743 1.45161 0.967743ZM15 29.0323C15.8003 29.0323 16.4516 28.381 16.4516 27.5806V23.2258H13.5484V27.5806C13.5484 28.381 14.1997 29.0323 15 29.0323ZM15.4839 22.2581H14.5161V21.2656C14.5531 21.268 14.5901 21.2706 14.627 21.2731C14.7505 21.2817 14.8741 21.2903 15 21.2903C15.1259 21.2903 15.2495 21.2817 15.373 21.2731L15.3733 21.2731C15.4101 21.2705 15.447 21.268 15.4839 21.2656V22.2581ZM8.2258 13.5484C8.2258 17.2839 11.2645 20.3226 15 20.3226C18.7355 20.3226 21.7742 17.2839 21.7742 13.5484C21.7742 9.8129 18.7355 6.77419 15 6.77419C11.2645 6.77419 8.2258 9.8129 8.2258 13.5484ZM22.7419 13.5484C22.7419 9.27968 19.2687 5.80645 15 5.80645C10.7313 5.80645 7.25807 9.27968 7.25807 13.5484C7.25807 14.9594 7.64371 16.2789 8.30565 17.4194H2.41936C1.61903 17.4194 0.967743 16.7681 0.967743 15.9677V4.83871H25.1613V15.9677C25.1613 16.5145 25.3505 17.0139 25.6577 17.4194H21.6944C22.3563 16.2789 22.7419 14.9594 22.7419 13.5484ZM27.5806 17.4194C28.381 17.4194 29.0323 16.7681 29.0323 15.9677V6.29032C29.0323 6.02371 28.815 5.80645 28.5484 5.80645H26.129V15.9677C26.129 16.7681 26.7803 17.4194 27.5806 17.4194Z"
    />
    <rect x="1.93549" y="1.93555" width="6.77419" height="0.967742" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.19354 13.5486C9.19354 10.3469 11.7982 7.74219 15 7.74219C18.2018 7.74219 20.8064 10.3469 20.8064 13.5486C20.8064 16.7504 18.2018 19.3551 15 19.3551C11.7982 19.3551 9.19354 16.7504 9.19354 13.5486ZM10.1613 13.5486C10.1613 16.2167 12.3319 18.3874 15 18.3874C17.6681 18.3874 19.8387 16.2167 19.8387 13.5486C19.8387 10.8806 17.6681 8.70993 15 8.70993C12.3319 8.70993 10.1613 10.8806 10.1613 13.5486Z"
    />
    <circle cx="15" cy="10.1616" r="0.483871" />
    <path d="M13.5484 12.581H14.5161V16.452H13.5484V17.4197H16.4516V16.452H15.4839V12.581H16.4516V11.6133H13.5484V12.581Z" />
    <rect x="1.93549" y="5.80664" width="4.35484" height="0.967742" />
    <rect x="1.93549" y="7.74219" width="4.35484" height="0.967742" />
    <rect x="5.32257" y="9.67773" width="0.967742" height="0.967742" />
    <rect x="1.93549" y="9.67773" width="2.41935" height="0.967742" />
  </svg>
);

export const UploadDocumentIconSvg = props => (
  <svg {...props} viewBox="0 0 25 30" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.741248 0.000749386C0.393587 0.033865 0.128383 0.329627 0.129889 0.68255V29.3182C0.129917 29.6947 0.431928 30 0.804492 30H23.741C24.1135 30 24.4155 29.6947 24.4156 29.3182V6.81876C24.417 6.63479 24.3447 6.45807 24.2153 6.32871L18.1439 0.192504C18.0168 0.0682177 17.8464 -0.000642606 17.6696 0.000749386H0.804492C0.783422 -0.000249795 0.762317 -0.000249795 0.741248 0.000749386ZM1.4791 1.36435H16.995V6.81876C16.995 7.19529 17.297 7.50052 17.6696 7.50056H23.0664V28.6364H1.4791V1.36435ZM22.1177 6.13696L18.3441 2.32313V6.13696H22.1177ZM8.80485 13.2959C8.68936 13.3136 8.5804 13.3613 8.48863 13.4344L4.10372 16.8434C3.89124 16.9836 3.77462 17.2325 3.80189 17.4875C3.82916 17.7425 3.99571 17.9605 4.23293 18.0516C4.47015 18.1428 4.7379 18.0916 4.92589 17.9193L8.22511 15.3519V22.8411C8.22167 23.087 8.34949 23.3157 8.55963 23.4396C8.76977 23.5636 9.02967 23.5636 9.2398 23.4396C9.44994 23.3157 9.57776 23.087 9.57432 22.8411V15.3519L12.8735 17.9193C13.0615 18.0916 13.3293 18.1428 13.5665 18.0516C13.8037 17.9605 13.9703 17.7425 13.9975 17.4875C14.0248 17.2325 13.9082 16.9836 13.6957 16.8434L9.3108 13.4344C9.16751 13.3212 8.98508 13.2712 8.80485 13.2959ZM3.88296 25.255C3.99373 25.0383 4.21048 24.8978 4.45155 24.8865C4.47262 24.8855 4.49372 24.8855 4.51479 24.8865H13.2846C13.5279 24.883 13.7542 25.0122 13.8768 25.2246C13.9995 25.437 13.9995 25.6996 13.8768 25.912C13.7542 26.1244 13.5279 26.2536 13.2846 26.2501H4.51479C4.27373 26.2616 4.04492 26.1422 3.91459 25.9369C3.78425 25.7317 3.77219 25.4717 3.88296 25.255Z"
    />
  </svg>
);

export const ConsentIconSvg = props => (
  <svg {...props} viewBox="0 0 25 30" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.94642 0C1.32549 0 0 1.31298 0 2.91869V4.24536C3.21428e-05 4.5384 0.23986 4.77603 0.535713 4.77603H10.7143H19.8214C20.1173 4.77603 20.3571 4.5384 20.3571 4.24536V2.91869C20.3571 1.88664 21.1902 1.06134 22.2321 1.06134C23.274 1.06134 24.1071 1.88664 24.1071 2.91869V25.2063C24.1071 26.8119 25.4326 28.125 27.0535 28.125C28.6754 28.1133 30.0088 26.7971 30 25.2063C29.9999 24.9133 29.7601 24.6756 29.4642 24.6756H26.25C25.5255 24.665 25.5255 25.7471 26.25 25.737H28.8469C28.6158 26.52 27.8855 27.0637 27.0535 27.0637C26.0117 27.0637 25.1785 26.2383 25.1785 25.2063V2.91869C25.1785 1.31298 23.853 0 22.2321 0C15.8359 0.00053067 9.36732 0 2.94642 0ZM2.94641 1.06134H19.9658C19.5216 1.57269 19.2857 2.19093 19.2857 2.91455V3.71055H10.7143H1.07141V2.91455C1.07141 1.8825 1.90454 1.05688 2.94641 1.0572V1.06134Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 4.375V25.2222C3.75 26.819 5.05096 28.125 6.64188 28.125H10V27.0694H6.64188C5.6193 27.0694 4.80159 26.2485 4.80159 25.2222V4.375H3.75Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7833 6.25005C16.5936 6.24723 16.4172 6.36573 16.3217 6.56025C16.2261 6.75476 16.2261 6.99524 16.3217 7.18975C16.4172 7.38427 16.5936 7.50277 16.7833 7.49995H20.7167C20.9064 7.50277 21.0828 7.38427 21.1783 7.18975C21.2739 6.99524 21.2739 6.75476 21.1783 6.56025C21.0828 6.36573 20.9064 6.24723 20.7167 6.25005H16.7833Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00652 6.25005C7.82632 6.24723 7.65883 6.36573 7.56807 6.56024C7.47731 6.75476 7.47731 6.99524 7.56807 7.18976C7.65883 7.38427 7.82632 7.50277 8.00652 7.49995H9.49348C9.67368 7.50277 9.84117 7.38427 9.93193 7.18976C10.0227 6.99524 10.0227 6.75476 9.93193 6.56024C9.84117 6.36573 9.67368 6.24723 9.49348 6.25005H8.00652Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7716 6.25005C11.586 6.24723 11.4135 6.36573 11.3201 6.56025C11.2266 6.75476 11.2266 6.99524 11.3201 7.18975C11.4135 7.38427 11.586 7.50277 11.7716 7.49995H15.1034C15.289 7.50277 15.4615 7.38427 15.5549 7.18975C15.6484 6.99524 15.6484 6.75476 15.5549 6.56025C15.4615 6.36573 15.289 6.24723 15.1034 6.25005H11.7716Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5276 13.125C10.3399 13.1222 10.1654 13.2407 10.0709 13.4352C9.97637 13.6298 9.97637 13.8702 10.0709 14.0648C10.1654 14.2593 10.3399 14.3778 10.5276 14.375H18.8474C19.0351 14.3778 19.2096 14.2593 19.3041 14.0648C19.3986 13.8702 19.3986 13.6298 19.3041 13.4352C19.2096 13.2407 19.0351 13.1222 18.8474 13.125H10.5276Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.656 10.625C13.4671 10.6222 13.2915 10.7407 13.1964 10.9352C13.1012 11.1298 13.1012 11.3702 13.1964 11.5648C13.2915 11.7593 13.4671 11.8778 13.656 11.875H20.719C20.9079 11.8778 21.0835 11.7593 21.1786 11.5648C21.2738 11.3702 21.2738 11.1298 21.1786 10.9352C21.0835 10.7407 20.9079 10.6222 20.719 10.625H13.656Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.06294 10.625C7.86266 10.6222 7.67652 10.7407 7.57565 10.9352C7.47478 11.1298 7.47478 11.3702 7.57565 11.5648C7.67652 11.7593 7.86266 11.8778 8.06294 11.875H11.9371C12.1373 11.8778 12.3235 11.7593 12.4243 11.5648C12.5252 11.3702 12.5252 11.1298 12.4243 10.9352C12.3235 10.7407 12.1373 10.6222 11.9371 10.625H8.06294Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2569 8.75005C19.0766 8.74723 18.909 8.86573 18.8181 9.06024C18.7273 9.25476 18.7273 9.49524 18.8181 9.68976C18.909 9.88427 19.0766 10.0028 19.2569 9.99995H20.7431C20.9234 10.0028 21.091 9.88427 21.1819 9.68976C21.2727 9.49524 21.2727 9.25476 21.1819 9.06024C21.091 8.86573 20.9234 8.74723 20.7431 8.75005H19.2569Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.04278 8.75005C7.84968 8.74723 7.6702 8.86573 7.57294 9.06024C7.47569 9.25476 7.47569 9.49524 7.57294 9.68976C7.6702 9.88427 7.84968 10.0028 8.04278 9.99995H12.5822C12.7753 10.0028 12.9548 9.88427 13.0521 9.68976C13.1493 9.49524 13.1493 9.25476 13.0521 9.06024C12.9548 8.86573 12.7753 8.74723 12.5822 8.75005H8.04278Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2567 8.75005C14.0764 8.74723 13.9089 8.86573 13.8181 9.06024C13.7273 9.25476 13.7273 9.49524 13.8181 9.68976C13.9089 9.88427 14.0764 10.0028 14.2567 9.99995H16.9933C17.1736 10.0028 17.3411 9.88427 17.4319 9.68976C17.5227 9.49524 17.5227 9.25476 17.4319 9.06024C17.3411 8.86573 17.1736 8.74723 16.9933 8.75005H14.2567Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.375 21.25C9.375 18.4949 11.6198 16.25 14.375 16.25C17.1302 16.25 19.375 18.4949 19.375 21.25C19.375 24.0052 17.1302 26.25 14.375 26.25C11.6198 26.25 9.375 24.0052 9.375 21.25ZM18.3223 21.25C18.3223 19.0639 16.5613 17.3027 14.375 17.3027C12.1887 17.3027 10.4276 19.0639 10.4276 21.25C10.4276 23.4363 12.1887 25.1974 14.375 25.1974C16.5613 25.1974 18.3223 23.4363 18.3223 21.25Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.875 20.9374C11.875 19.3909 13.1409 18.125 14.6875 18.125C16.2341 18.125 17.5 19.3909 17.5 20.9374C17.5 22.4841 16.2342 23.75 14.6875 23.75C13.1408 23.75 11.875 22.4841 11.875 20.9374ZM16.375 20.9374C16.375 19.9988 15.6261 19.25 14.6875 19.25C13.7489 19.25 13 19.9988 13 20.9374C13 21.8761 13.7488 22.625 14.6875 22.625C15.6262 22.625 16.375 21.8761 16.375 20.9374Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 25V31.9636C11.2501 32.1567 11.351 32.3349 11.5143 32.4302C11.6776 32.5254 11.878 32.5231 12.0391 32.424L14.376 30.9823L16.7109 32.424C16.872 32.5231 17.0724 32.5254 17.2357 32.4302C17.399 32.3349 17.4999 32.1567 17.5 31.9636V25H16.4566V31.0157L14.6424 29.8963C14.4777 29.7951 14.2723 29.7951 14.1076 29.8963L12.2934 31.0157V25L11.25 25Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 16.875V19.375H15V16.875H13.75Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20.625V21.875H12.5V20.625H10Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 20.625V21.875H18.75V20.625H16.25Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 23.75V30H15V23.75H13.75Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.75 27.5V28.75H26.875V27.5H18.75Z"
    />
  </svg>
);

export const GiroSetupIconSvg = props => (
  <svg {...props} viewBox="0 0 25 30" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.55 30.8C22.8537 30.8 23.1 30.5538 23.1 30.25V6.05C23.1 5.74624 22.8537 5.5 22.55 5.5H2.74995C2.44619 5.5 2.19995 5.74624 2.19995 6.05V30.25C2.19995 30.5538 2.44619 30.8 2.74995 30.8H22.55ZM3.29993 6.6H21.9999V16.5H3.29993V6.6ZM21.9999 17.6H3.29993V29.7H21.9999V17.6Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3 30.25C25.2982 31.768 24.068 32.9982 22.55 33H2.75C1.23197 32.9982 0.00181836 31.768 0 30.25V2.75C0.00181836 1.23197 1.23197 0.00181836 2.75 0H22.55C24.068 0.00181836 25.2982 1.23197 25.3 2.75V30.25ZM1.09998 2.75V30.25C1.09998 31.1613 1.83871 31.9 2.74998 31.9H22.55C23.4612 31.9 24.2 31.1613 24.2 30.25V2.75C24.2 1.83873 23.4612 1.1 22.55 1.1H2.74998C1.83871 1.1 1.09998 1.83873 1.09998 2.75Z"
    />
    <rect x="4.3999" y="9.90039" width="1.1" height="1.1" />
    <rect x="6.6001" y="9.90039" width="4.4" height="1.1" />
    <rect x="4.3999" y="18.6992" width="1.1" height="1.1" />
    <rect x="6.6001" y="18.6992" width="4.4" height="1.1" />
    <rect x="4.3999" y="20.9004" width="1.1" height="1.1" />
    <rect x="6.6001" y="20.9004" width="4.4" height="1.1" />
    <rect x="17.05" y="9.90039" width="3.85" height="1.1" />
    <path d="M18.7001 19.8008H17.6001V20.9008H15.4001C15.0963 20.9008 14.8501 21.147 14.8501 21.4508V23.6508C14.8501 23.9545 15.0963 24.2008 15.4001 24.2008H19.8001V25.3008H14.8501V26.4008H17.6001V27.5008H18.7001V26.4008H20.3501C20.6539 26.4008 20.9001 26.1545 20.9001 25.8508V23.6508C20.9001 23.347 20.6539 23.1008 20.3501 23.1008H15.9501V22.0008H20.9001V20.9008H18.7001V19.8008Z" />
  </svg>
);

export const PaymentIconSvg = props => (
  <svg {...props} viewBox="0 0 25 30" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6542 18.645C21.1855 17.6717 21.358 16.5426 21.1415 15.455L20.35 11.495V1.65C20.35 0.73873 19.6113 0 18.7 0H12.1C11.1887 0 10.45 0.73873 10.45 1.65V2.8996L9.03925 1.48885C8.72981 1.17935 8.31008 1.00548 7.87243 1.00548C7.43477 1.00548 7.01504 1.17935 6.7056 1.48885L2.03885 6.1556C1.39587 6.80061 1.39587 7.84424 2.03885 8.48925L2.4277 8.8781H1.65C0.73873 8.8781 0 9.61683 0 10.5281V17.1281C0 18.0394 0.73873 18.7781 1.65 18.7781H8.81485C8.45131 19.2516 8.25291 19.8312 8.25 20.4281V21.5281C8.25154 22.619 8.89942 23.6053 9.9 24.0399V25.3H8.8C8.49624 25.3 8.25 25.5462 8.25 25.85V29.15C8.25 29.4538 8.49624 29.7 8.8 29.7H9.35V32.45C9.35 32.7538 9.59624 33 9.9 33H18.7C19.0038 33 19.25 32.7538 19.25 32.45V29.7H19.8C20.1038 29.7 20.35 29.4538 20.35 29.15V25.85C20.35 25.5462 20.1038 25.3 19.8 25.3H18.7V22.22L20.6542 18.645ZM11.55 1.65C11.55 1.34624 11.7962 1.1 12.1 1.1H18.7C19.0038 1.1 19.25 1.34624 19.25 1.65V12.65C19.25 12.9538 19.0038 13.2 18.7 13.2H13.4024C13.0004 12.5649 12.3016 12.1794 11.55 12.1781V1.65ZM7.87243 2.10579C7.72645 2.10579 7.58646 2.16382 7.4833 2.2671L7.15 2.60095L10.45 5.90095V4.455L8.26155 2.2671C8.15839 2.16382 8.0184 2.10579 7.87243 2.10579ZM6.14955 3.60085L6.36955 3.38085L10.45 7.45635V9.0123L5.59405 4.15635L6.14955 3.60085ZM4.81635 4.93405L2.81655 6.9333C2.71284 7.0366 2.65459 7.17698 2.65469 7.32336C2.65479 7.46974 2.71324 7.61004 2.8171 7.7132L9.3621 14.2582C9.40295 13.5216 9.81187 12.8551 10.45 12.485V10.5677L4.81635 4.93405ZM1.1 10.5281C1.1 10.2243 1.34624 9.9781 1.65 9.9781H3.5277L4.5496 11H1.1V10.5281ZM5.5 12.1H1.1V13.2H6.7496L5.6243 12.0747C5.58404 12.0881 5.5423 12.0966 5.5 12.1ZM1.65 17.6781C1.34624 17.6781 1.1 17.4319 1.1 17.1281V14.3H7.7C7.7423 14.2966 7.78404 14.2881 7.8243 14.2747L9.33845 15.7888C9.3401 15.7905 9.34216 15.7916 9.34423 15.7927C9.34629 15.7938 9.34835 15.7949 9.35 15.7965V17.6781H1.65ZM10.45 31.9H18.15V29.7H10.45V31.9ZM19.25 26.4V28.6H9.35V26.4H19.25ZM17.6 22.0781C17.5999 21.9858 17.6232 21.895 17.6677 21.8141L19.6889 18.1175C20.0969 17.3707 20.2294 16.5042 20.0634 15.6695L19.7169 13.9392C19.4286 14.1712 19.0701 14.2984 18.7 14.3H13.75V14.3781C13.75 14.386 13.7476 14.3932 13.7453 14.4004C13.7427 14.4083 13.7401 14.4162 13.7407 14.4249C13.7412 14.4326 13.7432 14.4397 13.7453 14.4468C13.7477 14.4548 13.75 14.4628 13.75 14.4716V17.7716C13.75 18.0754 13.5038 18.3216 13.2 18.3216C12.8962 18.3216 12.65 18.0754 12.65 17.7716V14.4716C12.65 14.4637 12.6524 14.4565 12.6547 14.4493C12.6573 14.4414 12.6599 14.4335 12.6594 14.4249C12.6588 14.4171 12.6568 14.41 12.6547 14.4029C12.6523 14.3949 12.65 14.3869 12.65 14.3781C12.65 13.7706 12.1575 13.2781 11.55 13.2781C10.9425 13.2781 10.45 13.7706 10.45 14.3781V18.535C10.449 18.7305 10.3443 18.9108 10.175 19.0086C9.66456 19.2988 9.34948 19.8409 9.35 20.4281V21.5281C9.35259 22.278 9.86157 22.9315 10.588 23.1176C10.8306 23.1805 11 23.3994 11 23.65V25.3H17.6V22.0781Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.678 5.49922H15.478C15.1742 5.49922 14.928 5.25298 14.928 4.94922V2.74922C14.928 2.44546 15.1742 2.19922 15.478 2.19922H17.678C17.9817 2.19922 18.228 2.44546 18.228 2.74922V4.94922C18.228 5.25298 17.9817 5.49922 17.678 5.49922ZM17.128 3.29922H16.028V4.39922H17.128V3.29922Z"
    />
    <rect x="17.05" y="6.59961" width="1.1" height="1.1" />
    <rect x="17.05" y="6.59961" width="1.1" height="1.1" stroke="#A8A8A8" />
    <rect x="12.6499" y="2.19922" width="1.1" height="1.1" />
    <rect x="12.6499" y="2.19922" width="1.1" height="1.1" stroke="#A8A8A8" />
    <rect x="12.6499" y="4.40039" width="1.1" height="1.1" />
    <rect x="12.6499" y="4.40039" width="1.1" height="1.1" stroke="#A8A8A8" />
    <rect x="17.05" y="8.80078" width="1.1" height="1.1" />
    <rect x="17.05" y="8.80078" width="1.1" height="1.1" stroke="#A8A8A8" />
    <rect x="17.05" y="11" width="1.1" height="1.1" />
    <rect x="17.05" y="11" width="1.1" height="1.1" stroke="#A8A8A8" />
    <rect x="14.8501" y="6.59961" width="1.1" height="4.9731" />
    <rect
      x="14.8501"
      y="6.59961"
      width="1.1"
      height="4.9731"
      stroke="#A8A8A8"
    />
  </svg>
);

export const DocumentSkipSvgIcon = props => (
  <svg
    {...props}
    width="23"
    height="21"
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.33333 19.1667H10.1823C10.2875 19.6301 10.436 20.0752 10.622 20.5H2.33333C1.31448 20.5 0.5 19.6855 0.5 18.6667V2.33333C0.5 1.31448 1.31448 0.5 2.33333 0.5H18.6667C19.6855 0.5 20.5 1.31448 20.5 2.33333V10.622C20.0752 10.436 19.6301 10.2875 19.1667 10.1823V2.33333V1.83333H18.6667H2.33333H1.83333V2.33333V18.6667V19.1667H2.33333ZM5.16667 5.16667H15.8333V6.5H5.16667V5.16667ZM5.16667 9.83333H15.8333V10.1815C14.9818 10.3731 14.1918 10.7111 13.478 11.1667H5.16667V9.83333ZM5.16667 14.5H10V15.8333H5.16667V14.5Z"
      fill="#38576B"
      stroke="#38576B"
    />
    <path
      d="M21.4219 17.6936L21.6236 17.7446L21.6666 17.541L22.363 14.2432L22.4663 13.754L22.0541 14.037L20.9328 14.807C20.1092 13.5012 18.7231 12.633 17.1481 12.633C14.8718 12.633 13.0042 14.4328 12.6364 16.7649L12.6064 16.9556L12.7959 16.9924L13.6587 17.1599L13.8621 17.1994L13.8944 16.9948C14.166 15.2728 15.5307 13.9903 17.1481 13.9903C18.2644 13.9903 19.2584 14.5947 19.8581 15.5408L18.3491 16.5736L17.9834 16.8239L18.413 16.9325L21.4219 17.6936Z"
      fill="#38576B"
      stroke="#38576B"
      strokeWidth="0.4"
    />
  </svg>
);

export const DocumentSvgSkipIcon = props => (
  <svg {...props} viewBox="0 0 26 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4851 3.51467C18.2187 1.24827 15.2053 0 12 0C8.79467 0 5.78107 1.24827 3.51493 3.51467C1.24827 5.78107 0 8.79467 0 12C0 15.2053 1.24827 18.2187 3.51493 20.4853C5.78107 22.7517 8.79467 24 12 24C15.2053 24 18.2187 22.7517 20.4851 20.4853C22.7517 18.2187 24 15.2053 24 12C24 8.79467 22.7517 5.78107 20.4851 3.51467ZM4.40798 4.40772C6.43572 2.38025 9.13198 1.26318 12 1.26318C14.6562 1.26318 17.1643 2.22292 19.1315 3.97572L3.97572 19.1315C2.22292 17.164 1.26318 14.6562 1.26318 12C1.26318 9.13198 2.37998 6.43572 4.40798 4.40772ZM12 22.7368C14.868 22.7368 17.5642 21.6197 19.592 19.5922C21.62 17.564 22.7368 14.8677 22.7368 12C22.7368 9.34371 21.777 6.83597 20.0245 4.86877L4.86877 20.0245C6.83571 21.777 9.34371 22.7368 12 22.7368Z"
    />
  </svg>
);

export const DocumentAcceptSvgIcon = props => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8151 0C5.29615 0 0 5.37904 0 12C0 18.6209 5.29615 24 11.8151 24C18.334 24 23.6301 18.6209 23.6301 12C23.6301 5.37904 18.334 0 11.8151 0ZM11.8151 1.09091C17.7535 1.09091 22.556 5.96861 22.556 12C22.556 18.0314 17.7535 22.9091 11.8151 22.9091C5.87663 22.9091 1.0741 18.0314 1.0741 12C1.0741 5.96861 5.87663 1.09091 11.8151 1.09091ZM17.3114 7.27841C17.3995 7.16921 17.5258 7.09895 17.6638 7.08239C17.886 7.05341 18.1025 7.16749 18.2072 7.36863C18.3118 7.56977 18.2825 7.81574 18.1338 7.98579L10.8836 16.7131C10.7867 16.8293 10.6464 16.8991 10.4966 16.9056C10.3467 16.912 10.2011 16.8546 10.0948 16.7472L5.52989 12.1108C5.38903 11.9747 5.33155 11.772 5.37959 11.5807C5.42764 11.3894 5.57372 11.2394 5.76154 11.1884C5.94936 11.1375 6.1496 11.1937 6.28512 11.3352L10.4389 15.554L17.3114 7.27841Z"
      fill="#12B886"
    />
  </svg>
);

export const DocumentRejectSvgIcon = props => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8151 0C5.29615 0 0 5.37905 0 12C0 18.6209 5.29615 24 11.8151 24C18.334 24 23.6301 18.6209 23.6301 12C23.6301 5.37905 18.334 0 11.8151 0ZM11.8151 1.09091C17.7535 1.09091 22.556 5.96862 22.556 12C22.556 18.0314 17.7535 22.9091 11.8151 22.9091C5.87663 22.9091 1.0741 18.0314 1.0741 12C1.0741 5.96862 5.87663 1.09091 11.8151 1.09091ZM5.93018 6.3563C5.99876 6.15467 6.17676 6.01214 6.38581 5.99148C6.54791 5.97547 6.70841 6.03503 6.82217 6.15341L11.815 11.2244L16.8079 6.15341C16.8908 6.06583 17 6.00884 17.1184 5.99148C17.3505 5.95731 17.5775 6.08001 17.6793 6.29456C17.7811 6.50911 17.7341 6.76593 17.5631 6.92898L12.5703 12L17.5631 17.0625C17.704 17.1986 17.7615 17.4013 17.7134 17.5926C17.6654 17.7839 17.5193 17.9339 17.3315 17.9849C17.1437 18.0358 16.9434 17.9796 16.8079 17.8381L11.815 12.767L6.82217 17.8381C6.68665 17.9796 6.48641 18.0358 6.29859 17.9849C6.11076 17.9339 5.96469 17.7839 5.91664 17.5926C5.86859 17.4013 5.92608 17.1986 6.06694 17.0625L11.0598 12L6.06694 6.92898C5.91503 6.78166 5.86159 6.55793 5.93018 6.3563Z"
    />
  </svg>
);

export const PDFIconSvg = props => (
  <svg {...props} viewBox="0 0 13 17" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3799 16.2793C11.8353 16.2793 12.2192 16.1199 12.5315 15.8011C12.8438 15.4822 13 15.0951 13 14.6396V4.87988L8.12012 0H1.62012C1.16466 0 0.780781 0.159409 0.468468 0.478228C0.156156 0.797047 0 1.18418 0 1.63964V14.6396C0 15.0951 0.156156 15.4822 0.468468 15.8011C0.780781 16.1199 1.16466 16.2793 1.62012 16.2793H11.3799ZM11.3798 14.6399H1.62008V1.63985H7.31978V5.69991H11.3798V14.6399ZM3.13286 13.7609C2.8661 13.826 2.66114 13.7414 2.518 13.5072C2.38787 13.299 2.40088 13.0647 2.55704 12.8045C2.67415 12.5963 2.88236 12.3751 3.18166 12.1408C3.38987 11.9717 3.63061 11.809 3.90388 11.6528L4.25524 11.4576C4.95794 10.3125 5.40689 9.31049 5.60208 8.45163L5.6216 8.39308C5.53051 8.09378 5.45894 7.77496 5.40689 7.43662C5.35484 6.95514 5.36785 6.57776 5.44593 6.30449C5.56304 5.92711 5.79077 5.73842 6.12911 5.73842C6.38937 5.72541 6.57155 5.84903 6.67566 6.10929C6.75373 6.33051 6.77976 6.62331 6.75373 6.98767C6.74072 7.26094 6.69518 7.55374 6.6171 7.86605L6.5195 8.27596C6.6236 8.64032 6.81229 8.99818 7.08557 9.34953C7.29377 9.60979 7.53451 9.85053 7.80779 10.0718L8.15914 10.345C8.36735 10.28 8.66014 10.2409 9.03752 10.2279C9.53201 10.2149 9.90939 10.267 10.1697 10.3841C10.534 10.5402 10.6641 10.8005 10.56 11.1648C10.482 11.4381 10.2868 11.6138 9.97445 11.6919C9.72721 11.7439 9.40839 11.7309 9.018 11.6528C8.74473 11.6008 8.44543 11.5162 8.1201 11.3991L7.72971 11.2429C7.26124 11.282 6.77976 11.347 6.28527 11.4381C5.94693 11.5032 5.6216 11.5748 5.30929 11.6528L4.93842 11.77C4.63912 12.3295 4.33006 12.785 4.01124 13.1363C3.69242 13.4877 3.39963 13.6959 3.13286 13.7609ZM6.14866 7.53426L6.12914 7.45618C6.01202 6.55828 6.01853 6.11584 6.14866 6.12886C6.35686 6.15488 6.36337 6.59732 6.16818 7.45618L6.14866 7.53426ZM5.5435 10.5603L5.17263 11.263C5.47192 11.1459 5.92738 11.0158 6.53899 10.8726L7.37833 10.6774C6.87082 10.222 6.47393 9.70794 6.18764 9.13537L6.1486 9.07681C6.00546 9.51925 5.80376 10.0137 5.5435 10.5603ZM10.1697 11.1655C10.1566 11.2436 9.9094 11.2111 9.42792 11.0679C9.18067 10.9898 8.93993 10.9118 8.7057 10.8337C8.82281 10.8077 9.005 10.8044 9.25224 10.8239C9.49949 10.8434 9.71746 10.8857 9.90615 10.9508C10.0948 11.0159 10.1827 11.0874 10.1697 11.1655ZM3.10361 13.0486C2.99951 13.2373 2.97348 13.3349 3.02553 13.3414C3.07758 13.3479 3.16867 13.2926 3.2988 13.1755C3.42893 13.0583 3.56557 12.9152 3.70871 12.746C3.86487 12.5248 3.995 12.2906 4.0991 12.0433C3.90391 12.1214 3.70871 12.2711 3.51352 12.4923C3.34435 12.6745 3.20771 12.8599 3.10361 13.0486Z"
    />
  </svg>
);

export const EyeIconSvg = props => (
  <svg
    {...props}
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 4.5C9.33712 4.5 8.70124 4.76339 8.23239 5.23223C7.76355 5.70107 7.50016 6.33696 7.50016 7C7.50016 7.66304 7.76355 8.29893 8.23239 8.76777C8.70124 9.23661 9.33712 9.5 10.0002 9.5C10.6632 9.5 11.2991 9.23661 11.7679 8.76777C12.2368 8.29893 12.5002 7.66304 12.5002 7C12.5002 6.33696 12.2368 5.70107 11.7679 5.23223C11.2991 4.76339 10.6632 4.5 10.0002 4.5ZM10.0002 11.1667C8.89509 11.1667 7.83528 10.7277 7.05388 9.94628C6.27248 9.16488 5.8335 8.10507 5.8335 7C5.8335 5.89493 6.27248 4.83512 7.05388 4.05372C7.83528 3.27232 8.89509 2.83333 10.0002 2.83333C11.1052 2.83333 12.165 3.27232 12.9464 4.05372C13.7278 4.83512 14.1668 5.89493 14.1668 7C14.1668 8.10507 13.7278 9.16488 12.9464 9.94628C12.165 10.7277 11.1052 11.1667 10.0002 11.1667ZM10.0002 0.75C5.8335 0.75 2.27516 3.34167 0.833496 7C2.27516 10.6583 5.8335 13.25 10.0002 13.25C14.1668 13.25 17.7252 10.6583 19.1668 7C17.7252 3.34167 14.1668 0.75 10.0002 0.75Z"
      fill="#38576B"
    />
  </svg>
);

export const SiblingsIcon = props => (
  <svg
    {...props}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.60069 7.80002C5.04869 7.80002 4.60069 8.24802 4.60069 8.80002C4.60069 9.35202 5.04869 9.80002 5.60069 9.80002C6.15269 9.80002 6.60069 9.35202 6.60069 8.80002C6.60069 8.24802 6.15269 7.80002 5.60069 7.80002ZM10.3993 7.80002C9.84731 7.80002 9.39931 8.24802 9.39931 8.80002C9.39931 9.35202 9.84731 9.80002 10.3993 9.80002C10.9513 9.80002 11.3993 9.35202 11.3993 8.80002C11.3993 8.24802 10.9513 7.80002 10.3993 7.80002ZM8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8.00069 14.4C4.47269 14.4 1.60069 11.528 1.60069 8C1.60069 7.768 1.61669 7.536 1.64069 7.312C3.52869 6.472 5.02469 4.928 5.80869 3.016C7.25669 5.064 9.64069 6.4 12.3367 6.4C12.9607 6.4 13.5607 6.328 14.1367 6.192C14.3047 6.76 14.4007 7.368 14.4007 8C14.4007 11.528 11.5287 14.4 8.00069 14.4Z"
      fill="#38576B"
    />
  </svg>
);

export const MoveRightIconSvg = props => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.65"
      cy="11.65"
      r="9.7"
      fill="white"
      stroke="#EC6608"
      strokeWidth="2.5"
    />
    <path
      d="M5.2502 12.2445V12.4445H5.4502H14.8007L11.3227 15.9225L11.1812 16.0639L11.3227 16.2054L12.3088 17.1915L12.4502 17.3329L12.5916 17.1915L18.0916 11.6915L18.233 11.55L18.0916 11.4086L12.5916 5.90863L12.4502 5.76721L12.3088 5.90863L11.3227 6.89474L11.1812 7.03616L11.3227 7.17758L14.8007 10.6556H5.4502H5.2502V10.8556V12.2445Z"
      fill="#EC6608"
      stroke="#EC6608"
      strokeWidth="0.4"
    />
  </svg>
);

export const DownArrowIcon = props => (
  <svg
    {...props}
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.41 0L6 4.59L10.59 0L12 1.42L6 7.42L0 1.42L1.41 0Z"
      fill="#6C6C6C"
    />
  </svg>
);

export const FilterWithCountIcon = props => {
  const { circleColor, barColor, counter } = props;
  return (
    <svg
      {...props}
      width="34"
      height="32"
      viewBox="0 0 34 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill={circleColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4815 19.1495H16.1852V17.458H12.4815V19.1495ZM6 9V10.6916H22.6667V9H6ZM8.77779 14.9206H19.8889V13.229H8.77779V14.9206Z"
        fill={barColor}
      />
      {counter > 0 && (
        <g clipPath="url(#clip0)">
          <circle cx="25" cy="23.8639" r="7" fill="#F8F8F8" />
          <text x="22" y="27" fontWeight="bold" fontSize="10" fill="#38576B">
            {counter}
          </text>
        </g>
      )}
    </svg>
  );
};

export const TextboxCheck = props => (
  <svg
    {...props}
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.68 20L12.6 16.6667L13.8992 15.3778L15.68 17.1444L19.7008 13.1556L21 14.7222L15.68 20ZM10.976 20H2.24C0.9968 20 0 19 0 17.7778V2.22222C0 0.988889 0.9968 0 2.24 0H17.92C18.5141 0 19.0838 0.234126 19.5039 0.650874C19.924 1.06762 20.16 1.63285 20.16 2.22222V10.8889C19.1744 10.3222 18.0208 10 16.8 10L15.68 10.0889V8.88889H4.48V11.1111H13.0928C11.2784 12.3 10.08 14.3444 10.08 16.6667C10.08 17.8778 10.4048 19.0222 10.976 20ZM10.08 13.3333H4.48V15.5556H10.08V13.3333ZM15.68 4.44444H4.48V6.66667H15.68"
      fill="#38576B"
    />
  </svg>
);

export const FileDownload = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5996 16L17.5996 9.54529H14.1769V4H9.02229V9.54529H5.59961L11.5996 16ZM17.5996 20V18H5.59961V20H17.5996Z"
    />
  </svg>
);

export const FileUpload = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.59961 18H17.5996V20H5.59961V18Z" />
    <path d="M17.5996 10.4547L11.5996 4L5.59961 10.4547H9.02229V16H14.1769V10.4547H17.5996Z" />
  </svg>
);

export const ArrowCircleRightIcon = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" />
    <path
      d="M4.47834 10.5102V10.7102H4.67834H12.6361L9.69906 13.6473L9.55764 13.7887L9.69906 13.9301L10.5455 14.7766L10.6869 14.918L10.8284 14.7766L15.5494 10.0556L15.6908 9.91415L15.5494 9.77272L10.8284 5.05169L10.6869 4.91027L10.5455 5.05169L9.69906 5.89814L9.55764 6.03956L9.69906 6.18098L12.6361 9.11806H4.67834H4.47834V9.31806V10.5102Z"
      fill="white"
      stroke="white"
      strokeWidth="0.4"
    />
  </svg>
);
export const MenuDownIcon = props => {
  return (
    <svg
      {...props}
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.736572 0.339844L4.89657 4.49984L9.05657 0.339844H0.736572Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};

export const OrderIcon = props => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9062 10.2188C16.9688 10.2813 17 10.375 17 10.5C17 10.6458 16.9479 10.7656 16.8438 10.8594C16.7396 10.9531 16.6146 11 16.4688 11H7.53125C7.38542 11 7.26042 10.9531 7.15625 10.8594C7.05208 10.7656 7 10.6458 7 10.5C7 10.3958 7.03125 10.3125 7.09375 10.25L7.15625 10.1562L11.4062 5.28125C11.5938 5.09375 11.7917 5 12 5C12.2083 5 12.4062 5.09375 12.5938 5.28125L16.8438 10.1562L16.9062 10.2188Z"
      fill="#38576B"
    />
    <path
      d="M16.9062 14.7812C16.9688 14.7187 17 14.625 17 14.5C17 14.3542 16.9479 14.2344 16.8438 14.1406C16.7396 14.0469 16.6146 14 16.4688 14H7.53125C7.38542 14 7.26042 14.0469 7.15625 14.1406C7.05208 14.2344 7 14.3542 7 14.5C7 14.6042 7.03125 14.6875 7.09375 14.75L7.15625 14.8438L11.4062 19.7188C11.5938 19.9063 11.7917 20 12 20C12.2083 20 12.4062 19.9063 12.5938 19.7188L16.8438 14.8438L16.9062 14.7812Z"
      fill="#38576B"
    />
  </svg>
);

export const FileUploadSVG = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.59961 18H17.5996V20H5.59961V18Z" />
    <path d="M17.5996 10.4547L11.5996 4L5.59961 10.4547H9.02229V16H14.1769V10.4547H17.5996Z" />
  </svg>
);

export const UploadFileSVG = props => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.66 16.66C16.1267 16.66 16.5234 16.5 16.85 16.18C17.1767 15.86 17.34 15.4667 17.34 15V5L12.34 0H5.66003C5.2067 0 4.8167 0.163333 4.49003 0.49C4.16337 0.816667 4.00003 1.20667 4.00003 1.66V15C4.00003 15.4533 4.16003 15.8433 4.48003 16.17C4.80003 16.4967 5.19337 16.66 5.66003 16.66H15.66ZM16.08 5.84H11.5V1.24L16.08 5.84ZM15.66 18.34V20H2.34003C1.87337 20 1.4767 19.84 1.15003 19.52C0.823368 19.2 0.660034 18.8067 0.660034 18.34V3.34H2.34003V18.34H15.66Z"
      fill="#38576B"
    />
  </svg>
);

export const ArrowRotateIcon = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 8L15 12H18C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C11 18 10.03 17.75 9.2 17.3L7.74 18.76C8.97 19.54 10.43 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12H23L19 8ZM6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13 6 13.97 6.25 14.8 6.7L16.26 5.24C15.03 4.46 13.57 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12H1L5 16L9 12"
      fill="#38576B"
    />
  </svg>
);

export const ArrowDropUp = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9062 10.2188C16.9688 10.2813 17 10.375 17 10.5C17 10.6458 16.9479 10.7656 16.8438 10.8594C16.7396 10.9531 16.6146 11 16.4688 11H7.53125C7.38542 11 7.26042 10.9531 7.15625 10.8594C7.05208 10.7656 7 10.6458 7 10.5C7 10.3958 7.03125 10.3125 7.09375 10.25L7.15625 10.1562L11.4062 5.28125C11.5938 5.09375 11.7917 5 12 5C12.2083 5 12.4062 5.09375 12.5938 5.28125L16.8438 10.1562L16.9062 10.2188Z"
      fill="#38576B"
    />
    <path
      d="M16.9062 14.7812C16.9688 14.7187 17 14.625 17 14.5C17 14.3542 16.9479 14.2344 16.8438 14.1406C16.7396 14.0469 16.6146 14 16.4688 14H7.53125C7.38542 14 7.26042 14.0469 7.15625 14.1406C7.05208 14.2344 7 14.3542 7 14.5C7 14.6042 7.03125 14.6875 7.09375 14.75L7.15625 14.8438L11.4062 19.7188C11.5938 19.9063 11.7917 20 12 20C12.2083 20 12.4062 19.9063 12.5938 19.7188L16.8438 14.8438L16.9062 14.7812Z"
      fill="#CFCFCF"
    />
  </svg>
);

export const ArrowDropDown = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9062 10.2188C16.9688 10.2813 17 10.375 17 10.5C17 10.6458 16.9479 10.7656 16.8438 10.8594C16.7396 10.9531 16.6146 11 16.4688 11H7.53125C7.38542 11 7.26042 10.9531 7.15625 10.8594C7.05208 10.7656 7 10.6458 7 10.5C7 10.3958 7.03125 10.3125 7.09375 10.25L7.15625 10.1562L11.4062 5.28125C11.5938 5.09375 11.7917 5 12 5C12.2083 5 12.4062 5.09375 12.5938 5.28125L16.8438 10.1562L16.9062 10.2188Z"
      fill="#CFCFCF"
    />
    <path
      d="M16.9062 14.7812C16.9688 14.7187 17 14.625 17 14.5C17 14.3542 16.9479 14.2344 16.8438 14.1406C16.7396 14.0469 16.6146 14 16.4688 14H7.53125C7.38542 14 7.26042 14.0469 7.15625 14.1406C7.05208 14.2344 7 14.3542 7 14.5C7 14.6042 7.03125 14.6875 7.09375 14.75L7.15625 14.8438L11.4062 19.7188C11.5938 19.9063 11.7917 20 12 20C12.2083 20 12.4062 19.9063 12.5938 19.7188L16.8438 14.8438L16.9062 14.7812Z"
      fill="#38576B"
    />
  </svg>
);
